const IS_LOADING = "campaigns/showFailures/showFailureSchedule/IS_LOADING";
const SHOWFAILURE_SCHEDULE_DATA = "campaigns/showFailures/showFailureSchedule/FAILURE_DATA";
const IS_ERROR = "campaigns/showFailures/showFailureSchedule/IS_ERROR";
const FILTER = "campaigns/showFailures/showFailureSchedule/FILTER";

export { IS_LOADING, SHOWFAILURE_SCHEDULE_DATA, IS_ERROR, FILTER };
